
// store.js
import { createStore } from 'vuex';
import userDetails  from '../UserManagement/userdata.js';

export default createStore({
  modules: {
    rentalPayments: {
      state: {
        rentalPayments: [
          { id: 1, landlord: 'Ram', address: 'Hyderabad', panNumber: 'FLNBM88776G',paymentType:"Shop Rent",Mobile: '7688743654', Amount: '10000' },
          { id: 2, landlord: 'Rahul', address: 'Hyderabad', panNumber: 'FLABM88776G',  paymentType:"Broker Payment",Mobile: '8688743654', Amount: '20000' },
          { id: 3, landlord: 'Rakesh', address: 'Andhra Pradesh', panNumber: 'RLTBM82776G',  paymentType:"Society Maintenance", Mobile: '9688743654', Amount: '20000' },
          { id: 4, landlord: 'Ramu', address: 'Andhra Pradesh', panNumber: 'ALNBM88176G', paymentType:"House Rent", Mobile: '9888874364', Amount: '30000' }
        ]
      },
      getters: {
        rentalPayments: (state) => state.rentalPayments,
        totalRecords: (state) => state.rentalPayments.length
      },
      mutations: {
        ADD_RENTAL_PAYMENT(state, newPayment) {
          state.rentalPayments.push(newPayment);
        },
        UPDATE_RENTAL_PAYMENT(state, updatedPayment) {
          const index = state.rentalPayments.findIndex(p => p.id === updatedPayment.id);
          if (index !== -1) {
            state.rentalPayments[index] = updatedPayment;
          }
        },
        DELETE_RENTAL_PAYMENT(state, RentalId) {
          state.rentalPayments = state.rentalPayments.filter(rental => rental.id !== RentalId);
        }
      },
      actions: {
        addRentalPayment({ commit }, newPayment) {
          commit('ADD_RENTAL_PAYMENT', newPayment);
        },
        updateRentalPayment({ commit }, updatedPayment) {
          commit('UPDATE_RENTAL_PAYMENT', updatedPayment);
        },
        deleteRentalPayment({ commit }, RentalId) {
          commit('DELETE_RENTAL_PAYMENT', RentalId);
        }
      }
    },
    userDetails:userDetails
  }
});

